import React from 'react';
import { View } from 'react-native';
import moment from 'moment';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
import { Divider } from '../../Divider';
import { Focusable } from '../../Focusable';
import { Text } from '../../Text';
const weekdays = moment.weekdays();
export const Days = ({ data }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.container },
        weekdays.map((day, index) => (React.createElement(View, { key: day, style: [styles.day, index !== 0 ? styles.dayWithMargin : {}] },
            React.createElement(View, { style: styles.hours }, data[day].map((interval) => (React.createElement(Focusable, { key: interval.left, style: [
                    styles.interval,
                    {
                        left: `${interval.left}%`,
                        width: `${interval.width}%`
                    }
                ] }, ({ hovered }) => (React.createElement(React.Fragment, null, hovered && (React.createElement(View, { style: [styles.tooltip] },
                React.createElement(Text, { type: 'headline', size: 'md' },
                    interval.from,
                    "-",
                    interval.to)))))))))))),
        React.createElement(Divider, { type: 'vertical', style: [styles.divider, { right: '0%' }] }),
        React.createElement(Divider, { type: 'vertical', style: [styles.divider, { right: '25%' }] }),
        React.createElement(Divider, { type: 'vertical', style: [styles.divider, { right: '50%' }] }),
        React.createElement(Divider, { type: 'vertical', style: [styles.divider, { right: '75%' }] }),
        React.createElement(Divider, { type: 'vertical', style: [styles.divider, { right: '100%' }] })));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        paddingTop: size.G,
        marginTop: size.A
    },
    day: {
        alignItems: 'center',
        flexDirection: 'row',
        height: size.M,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
        // @ts-ignore
        zIndex: 'unset'
    },
    dayWithMargin: { marginTop: size.C },
    hours: {
        backgroundColor: color.invert2.p4,
        flex: 1,
        height: '100%',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
        // @ts-ignore
        zIndex: 'unset'
    },
    interval: {
        backgroundColor: color.primary.solid,
        position: 'absolute',
        height: '100%',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
        // @ts-ignore
        zIndex: 'unset'
    },
    divider: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
        // @ts-ignore
        zIndex: 'unset'
    },
    tooltip: {
        zIndex: 99,
        backgroundColor: color.bg.v3,
        borderRadius: size.C,
        padding: size.D,
        position: 'absolute',
        width: 120,
        left: `calc(50% - 60px)`,
        flexDirection: 'row',
        justifyContent: 'center',
        bottom: 'calc(100% + 8px)',
        boxShadow: '0px 8px 42px rgba(28, 29, 40, 0.1)'
    },
    tooltip__label: {
        color: color.invert2.p42
    }
}));
//# sourceMappingURL=Days.js.map